/**
 * Router (PHASE1 §7.1). A single `AppShell` layout wraps every route; the P0
 * SPA-fallback serves these client paths. Query owns all data, so there are no
 * route loaders. `/` redirects to `/inbox`; unknown paths fall back to `/inbox`.
 */
import { createBrowserRouter, Navigate } from 'react-router';
import { AppShell } from './components/layout/AppShell.tsx';
import InboxPage from './pages/InboxPage.tsx';
import TransactionsPage from './pages/TransactionsPage.tsx';
import AccountsPage from './pages/AccountsPage.tsx';
import BucketsPage from './pages/BucketsPage.tsx';
import RulesPage from './pages/RulesPage.tsx';
import VertraegePage from './pages/VertraegePage.tsx';
import ImportPage from './pages/ImportPage.tsx';
import BelegePage from './pages/BelegePage.tsx';
import BudgetPage from './pages/BudgetPage.tsx';
import BerichtePage from './pages/BerichtePage.tsx';
import TransfersPage from './pages/TransfersPage.tsx';
import ExportPage from './pages/ExportPage.tsx';
import ConnectionsPage from './pages/connections/ConnectionsPage.tsx';
import SetupWizard from './pages/connections/SetupWizard.tsx';
import FintsSetupPage from './pages/connections/FintsSetupPage.tsx';
import ConnectionDetailPage from './pages/connections/ConnectionDetailPage.tsx';
import ConnectCallbackResult from './pages/connections/ConnectCallbackResult.tsx';
import AdminPage from './pages/AdminPage.tsx';

export const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/inbox" replace /> },
      { path: 'inbox', element: <InboxPage /> },
      { path: 'transaktionen', element: <TransactionsPage /> },
      { path: 'budget', element: <BudgetPage /> },
      { path: 'berichte', element: <BerichtePage /> },
      { path: 'transfers', element: <TransfersPage /> },
      { path: 'daten-export', element: <ExportPage /> },
      { path: 'konten', element: <AccountsPage /> },
      { path: 'kategorien', element: <BucketsPage /> },
      { path: 'regeln', element: <RulesPage /> },
      { path: 'import', element: <ImportPage /> },
      { path: 'belege', element: <BelegePage /> },
      { path: 'bankverbindungen', element: <ConnectionsPage /> },
      { path: 'bankverbindungen/einrichten', element: <SetupWizard /> },
      { path: 'bankverbindungen/einrichten/fints', element: <FintsSetupPage /> },
      { path: 'bankverbindungen/:id', element: <ConnectionDetailPage /> },
      { path: 'verbindung/erfolg', element: <ConnectCallbackResult /> },
      { path: 'verbindung/fehler', element: <ConnectCallbackResult /> },
      { path: 'admin', element: <AdminPage /> },
      { path: 'vertraege', element: <VertraegePage /> },
      { path: '*', element: <Navigate to="/inbox" replace /> },
    ],
  },
]);
